import { observer } from 'mobx-react-lite'
import { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import { useJsApiLoader } from '@react-google-maps/api'
import Main from './Main'
import { useStore } from './app/stores/store'
import PageLoader from './design/components/loaders/PageLoader'
import CookieConsent from './app/modals/CookieConsent'

function App() {
  const { commonStore, userStore, favoriteAuctionsStore, logsStore } = useStore()
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API as string,
    libraries: ['places'],
  })
  const [decisionTaken, setDecisionTaken] = useState<boolean>(false)

  const cookiesAccepted = localStorage.getItem('ha_cookie')

  const [isApiLoaded, setIsApiLoaded] = useState<boolean>(false)
  const [loadingLogs, setLoadingLogs] = useState<boolean>(true)

  useEffect(() => {
    if (isLoaded) {
      setIsApiLoaded(true)
    }
  }, [isLoaded])

  useEffect(() => {
    if (commonStore.token) {
      userStore
        .getUser()
        .catch(() => {
          toast.error('Session expired - please login again')
          commonStore.setToken('')
        })
        .finally(() => commonStore.setAppLoaded())
    } else {
      userStore.getGoogleLoginStatus().then(() => commonStore.setAppLoaded())
    }
  }, [commonStore, userStore, commonStore.token])

  useEffect(() => {
    if (userStore.isLoggedIn) {
      favoriteAuctionsStore.loadFavorite()
    }
  }, [userStore.isLoggedIn, userStore, favoriteAuctionsStore])

  useEffect(() => {
    setLoadingLogs(true)
    logsStore.loadLogs().finally(() => {
      setLoadingLogs(false)
    })
  }, [logsStore])

  if (!commonStore.appLoaded || !isApiLoaded || loadingLogs) {
    return <PageLoader />
  }

  return (
    <>
      <ToastContainer position='bottom-right' theme='light' closeOnClick hideProgressBar />
      <Main />
      {cookiesAccepted !== 'true' && !decisionTaken && window.location.pathname !== '/datenschutzrichtlinien' && (
        <CookieConsent decisionTaken={() => setDecisionTaken(true)} />
      )}
    </>
  )
}

export default observer(App)
